import { normalizeStoredText } from '../utils/richText';

export const DEFAULT_CORE_BELIEFS = [
  {
    title: 'The Trinity',
    description:
      'We believe in one God, eternally existing in three persons: the Father, the Son, and the Holy Spirit. This divine unity works in harmony for creation, redemption, and sustenance.',
    verse_text:
      'Go therefore and make disciples of all nations, baptizing them in the name of the Father and of the Son and of the Holy Spirit.',
    verse_ref: 'Matthew 28:19',
  },
  {
    title: 'Scripture',
    description:
      'The Bible is the inspired Word of God, infallible and authoritative for teaching, reproof, correction, and training in righteousness.',
    verse_text:
      'All Scripture is breathed out by God and profitable for teaching, for reproof, for correction, and for training in righteousness.',
    verse_ref: '2 Timothy 3:16',
  },
  {
    title: 'Salvation',
    description:
      'Salvation is a gift of grace through faith in Jesus Christ. It is available to all who repent of their sins and accept Him as their Lord and Savior.',
    verse_text:
      'For it is by grace you have been saved, through faith—and this is not from yourselves, it is the gift of God.',
    verse_ref: 'Ephesians 2:8',
  },
  {
    title: 'Baptism',
    description:
      'Baptism is an outward expression of an inward faith, symbolizing the believer’s union with Christ in His death, burial, and resurrection.',
    verse_text:
      'Therefore we are buried with him by baptism into death: that like as Christ was raised up from the dead by the glory of the Father, even so we also should walk in newness of life.',
    verse_ref: 'Romans 6:4',
  },
  {
    title: 'Holy Spirit',
    description:
      'The Holy Spirit empowers believers, guiding them in truth and enabling them to live holy and fruitful lives.',
    verse_text:
      'But the Helper, the Holy Spirit, whom the Father will send in my name, he will teach you all things and bring to your remembrance all that I have said to you.',
    verse_ref: 'John 14:26',
  },
  {
    title: 'Sanctification',
    description:
      'Sanctification is the process by which believers are transformed into the likeness of Christ through the work of the Holy Spirit.',
    verse_text:
      'And we all, who with unveiled faces contemplate the Lord’s glory, are being transformed into his image with ever-increasing glory, which comes from the Lord, who is the Spirit.',
    verse_ref: '2 Corinthians 3:18',
  },
  {
    title: 'Second Coming',
    description:
      'We believe in the imminent return of Jesus Christ to judge the living and the dead and to establish His eternal kingdom.',
    verse_text:
      'For the Lord himself will come down from heaven, with a loud command, with the voice of the archangel and with the trumpet call of God, and the dead in Christ will rise first.',
    verse_ref: '1 Thessalonians 4:16',
  },
  {
    title: 'Evangelism',
    description:
      'We are called to share the Gospel with all nations, proclaiming the good news of Jesus Christ to the world.',
    verse_text: 'Go into all the world and preach the gospel to all creation.',
    verse_ref: 'Mark 16:15',
  },
];

const FIELD_MAP = {
  title: 'title',
  description: 'description',
  verse_text: 'verse_text',
  verse_ref: 'verse_ref',
};

function normalizeBelief(belief, index) {
  return {
    title: normalizeStoredText(belief.title || DEFAULT_CORE_BELIEFS[index]?.title || ''),
    description: normalizeStoredText(belief.description || DEFAULT_CORE_BELIEFS[index]?.description || ''),
    verse_text: normalizeStoredText(belief.verse_text || DEFAULT_CORE_BELIEFS[index]?.verse_text || ''),
    verse_ref: normalizeStoredText(belief.verse_ref || DEFAULT_CORE_BELIEFS[index]?.verse_ref || ''),
  };
}

export function resolveCoreBeliefs(getContent) {
  const stored = getContent('beliefs.items', null);
  if (Array.isArray(stored) && stored.length) {
    return stored.map((belief, index) => normalizeBelief(belief, index));
  }

  return DEFAULT_CORE_BELIEFS.map((belief, index) =>
    normalizeBelief(
      {
        title: getContent(`beliefs.${index}.title`, belief.title),
        description: getContent(`beliefs.${index}.description`, belief.description),
        verse_text: getContent(`beliefs.${index}.verse_text`, belief.verse_text),
        verse_ref: getContent(`beliefs.${index}.verse_ref`, belief.verse_ref),
      },
      index
    )
  );
}

export function saveCoreBeliefField(setContentValue, beliefs, index, field, value) {
  const next = beliefs.map((item, idx) => (idx === index ? { ...item, [field]: value } : item));
  setContentValue('beliefs.items', next);
}

export { FIELD_MAP };
